import { useEffect, useState } from "react";
import { scrollToId } from "./Reveal";
import { apiFetch, IS_STATIC } from "@/lib/api";
import { getContent, loadRemoteContent, hasLocalOverrides } from "@/lib/staticData";
import Socials from "./Socials";

export default function Footer() {
  const [time, setTime] = useState("");
  const [site, setSite] = useState(IS_STATIC ? getContent().settings : {});

  useEffect(() => {
    const fmt = new Intl.DateTimeFormat("en-AU", {
      timeZone: "Australia/Adelaide",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });
    const tick = () => setTime(fmt.format(new Date()));
    tick();
    const t = setInterval(tick, 1000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    if (IS_STATIC) {
      loadRemoteContent().then((c) => {
        if (c && !hasLocalOverrides()) setSite(c.settings);
      });
      return;
    }
    apiFetch("/settings").then(setSite).catch(() => {});
  }, []);

  const phone1 = site.phone1 || "0406 646 061";
  const phone2 = site.phone2 || "0481 783 135";
  const email = site.notification_email || "Strovyn@gmail.com";
  const location = site.location || "Adelaide, South Australia";
  const socials = [
    ["Instagram", site.instagram],
    ["Facebook", site.facebook],
    ["TikTok", site.tiktok],
    ["LinkedIn", site.linkedin],
  ].filter(([, url]) => url);

  return (
    <footer className="bg-[#0B0A09] text-[#F5F3EF]" data-testid="footer">
      <div className="mx-auto max-w-7xl px-4 pb-10 pt-16 sm:px-8">
        <p className="select-none font-serif text-[17vw] uppercase leading-[0.85] tracking-tight lg:text-[12.5rem]">
          STROVYN
        </p>

        <div className="mt-14 grid gap-10 border-t border-white/10 pt-12 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <img src="/logo-wide.png" alt="Strovyn Painting Co." className="h-9 w-auto" />
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-white/50">
              Premium painting and specialty finishes for Adelaide's homes,
              businesses and heritage places.
            </p>
            <div className="mt-6">
              <Socials site={site} variant="dark" />
            </div>
          </div>
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-accent">Explore</p>
            <ul className="mt-4 space-y-2 text-sm">
              {[
                ["services", "Services"],
                ["gallery", "Work"],
                ["manifesto", "Process"],
                ["careers", "Careers"],
                ["contact", "Contact"],
              ].map(([id, label]) => (
                <li key={id}>
                  <button onClick={() => scrollToId(id)} className="text-white/50 transition-colors hover:text-accent">
                    {label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-accent">Location</p>
            <p className="mt-4 text-sm leading-relaxed text-white/50">
              {location}
              <br />
              Servicing greater Adelaide
              <br />
              Mon–Sat, 7:00–17:00
            </p>
          </div>
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-accent">Contact</p>
            <p className="mt-4 text-sm leading-relaxed text-white/50">
              {phone1}
              <br />
              {phone2}
              <br />
              {email}
            </p>
            <p className="mt-6 font-mono text-xs text-white/40" data-testid="footer-clock">
              Adelaide — {time} ACST
            </p>
          </div>
        </div>

        <div className="mt-14 flex justify-center border-t border-white/10 pt-6 font-mono text-[10px] uppercase tracking-[0.2em] text-white/40">
          <p>© 2026 Strovyn Painting Co. — {location} · ABN 50 847 246 528</p>
        </div>
      </div>
    </footer>
  );
}
